module.exports = "/_next/static/images/humbaur-logo-6b9f91c6aa7734aaf5a8bdc4472a3d60.png";